module.exports = __webpack_public_path__ + "img/top1.f4c7faf6.png";